module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_07.png?ce32e3aa682f85bb5c523bd576b717be";